import { useParams, useNavigate } from "react-router-dom";
import LoginForm from "../components/LoginForm";

export default function LoginPage() {
  const { site } = useParams();
  const navigate = useNavigate();

  const handleSwitch = (newSite) => {
    navigate(`/${newSite}/login`);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="w-full max-w-md bg-white/90 backdrop-blur-lg p-8 shadow-2xl rounded-2xl border border-gray-200">
        {/* Site Switcher */}
        <div className="flex justify-center mb-6 space-x-3">
          <button
            onClick={() => handleSwitch("GIC")}
            className={`px-5 py-2 rounded-xl font-medium transition-all duration-300 ${
              site === "GIC"
                ? "bg-blue-600 text-white shadow-lg scale-105"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }`}
          >
            GIC
          </button>
          <button
            onClick={() => handleSwitch("LIC")}
            className={`px-5 py-2 rounded-xl font-medium transition-all duration-300 ${
              site === "LIC"
                ? "bg-blue-600 text-white shadow-lg scale-105"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }`}
          >
            LIC
          </button>
        </div>

        {/* Title */}
        <h2 className="text-3xl font-extrabold text-center text-gray-800 mb-8">
          {site === "GIC" ? "Welcome to GIC" : "Welcome to LIC"}
        </h2>

        {/* Login Form */}
        <LoginForm site={site} />
      </div>
    </div>
  );
}
